import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { UserStore } from '@app/core/services/user.store';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { LabourerItem, LabourService } from '@app/services/labour.service';

@Component({
  selector: 'tt-select-labour',
  templateUrl: './select-labour.component.html',
  styleUrls: ['./select-labour.component.css'],
  standalone: false,
})
export class SelectLabourComponent implements OnInit, OnDestroy {
    public items: LabourerItem[] = [];
    public activeStatus: 'ACT' | 'NOT_ACT' | 'ALL' = 'ACT';
    public selecting = false;
    public error = '';
    public canSelect = () => !this.selecting;
    private loadRevision = 0;
    constructor(private labour: LabourService, private user: UserStore, @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) { this.navigator = useNavigatorFor(navigator, this); }
    public async ngOnInit(): Promise<void> { await this.loadLabours(); }
    private async loadLabours(): Promise<void> {
        const revision = ++this.loadRevision;
        this.items = [];
        this.error = '';
        try { const items = await this.labour.getLabourers({ activestatus: this.activeStatus }); if (revision === this.loadRevision) this.items = items; }
        catch (error) { if (revision === this.loadRevision) this.showError(error); }
    }
    public async onStatusChanged(value: string): Promise<void> {
        if (value !== 'ACT' && value !== 'NOT_ACT' && value !== 'ALL') return;
        if (value === this.activeStatus) return;
        this.activeStatus = value;
        await this.loadLabours();
    }
    public async select(item: LabourerItem): Promise<void> {
        if (this.selecting || item.item_id === '') return;
        this.selecting = true;
        this.error = '';
        try {
            this.user.userEditCache.selectedLabourNo = String(item.item_id);
            this.user.userEditCache.selectedLabourName = item.item_name;
            await this.navigator?.back();
        } catch (error) { this.showError(error); }
        finally { this.selecting = false; }
    }
    public addLabour(event?: { ctrlKey?: boolean }): void {
        const target = { to: 'labouredit', parms: { labour_no: '0' } };
        if (event?.ctrlKey) this.navigator?.newTab(target); else this.navigator?.go(target);
    }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
    public ngOnDestroy(): void { ++this.loadRevision; }

}
